export default function TrustSection() {
  const trustItems = [
    {
      icon: "ri-refresh-line",
      image: "https://readdy.ai/api/search-image?query=Calendar%20pages%20flipping%20concept%20with%20fashion%20accessories%20on%20warm%20cream%20surface%2C%20daily%20planner%20with%20marked%20dates%20next%20to%20premium%20watch%2C%20soft%20natural%20light%20from%20window%2C%20editorial%20photography%20style%2C%20warm%20beige%20and%20sand%20tones%2C%20organization%20and%20freshness%20theme%2C%20clean%20minimalist%20composition%2C%20time%20management%20aesthetic&width=400&height=300&seq=trust-v2-daily-01&orientation=landscape",
      title: "Atualizações Diárias",
      desc: "Preços e disponibilidade verificados a cada 24 horas, garantindo informações sempre atualizadas para suas compras."
    },
    {
      icon: "ri-shield-check-line",
      image: "https://readdy.ai/api/search-image?query=Verification%20checkmark%20concept%20with%20magnifying%20glass%20examining%20designer%20handbag%20and%20sneakers%20on%20cream%20surface%2C%20quality%20control%20inspection%20theme%2C%20soft%20natural%20window%20light%2C%20editorial%20photography%2C%20warm%20sand%20tones%2C%20trust%20and%20authentication%20aesthetic%2C%20clean%20composition%2C%20premium%20product%20validation&width=400&height=300&seq=trust-v2-verified-02&orientation=landscape",
      title: "Produtos Verificados",
      desc: "Comunidade ativa testa cada link antes da inclusão, eliminando produtos falsificados e vendedores não confiáveis."
    },
    {
      icon: "ri-links-line",
      image: "https://readdy.ai/api/search-image?query=Connected%20chain%20links%20concept%20with%20multiple%20fashion%20product%20cards%20connected%20by%20golden%20threads%20on%20warm%20cream%20background%2C%20network%20and%20connectivity%20symbolism%2C%20soft%20natural%20lighting%2C%20editorial%20photography%20style%2C%20warm%20beige%20tones%2C%20active%20links%20and%20reliability%20theme%2C%20clean%20modern%20composition&width=400&height=300&seq=trust-v2-links-03&orientation=landscape",
      title: "Links Testados e Ativos",
      desc: "Todos os links são validados regularmente. Nada de links quebrados ou páginas indisponíveis na planilha."
    },
    {
      icon: "ri-spam-line",
      image: "https://readdy.ai/api/search-image?query=Clean%20authentic%20products%20concept%20with%20real%20premium%20sneakers%20and%20leather%20goods%20on%20warm%20cream%20surface%2C%20genuine%20quality%20label%20visible%2C%20soft%20natural%20light%2C%20editorial%20photography%2C%20warm%20sand%20tones%2C%20authenticity%20and%20transparency%20aesthetic%2C%20honest%20product%20display%2C%20no%20fake%20items%20symbolism%2C%20clean%20composition&width=400&height=300&seq=trust-v2-nospam-04&orientation=landscape",
      title: "Sem Spam, Sem Listas Falsas",
      desc: "Apenas produtos reais com curadoria rigorosa. Nada de propaganda enganosa ou listas infladas artificialmente."
    }
  ];

  const metrics = [
    { value: "14", label: "Categorias" },
    { value: "10.000+", label: "Itens Catalogados" },
    { value: "Diária", label: "Atualização" },
    { value: "100%", label: "Links Verificados" }
  ];

  return (
    <section className="relative py-28 md:py-36 bg-accent-50/60">
      <div className="max-w-[1280px] mx-auto px-6 md:px-16">
        {/* Header */}
        <div className="text-center md:text-left">
          <span className="inline-block px-4 py-1.5 rounded-full bg-white text-foreground-700 text-xs font-semibold uppercase tracking-wider whitespace-nowrap">
            Por que confiar
          </span>
          <h2 className="mt-5 text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            A Maior Base de Dados<br />
            Organizada para Compras
          </h2>
        </div>

        {/* Trust Items */}
        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {trustItems.map((item, idx) => (
            <div key={idx} className="flex flex-col bg-white rounded-2xl overflow-hidden border border-secondary-200/70 transition-transform hover:scale-[1.02]">
              <div className="w-full h-[180px] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="p-5 flex flex-col gap-2">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className={`${item.icon} text-sm`}></i>
                  </div>
                  <h4 className="text-foreground-900 font-semibold text-sm whitespace-nowrap">{item.title}</h4>
                </div>
                <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Metrics */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8">
          {metrics.map((metric, idx) => (
            <div key={idx} className="text-center">
              <p className="text-5xl md:text-6xl font-heading font-extrabold text-accent-700 leading-none">
                {metric.value}
              </p>
              <p className="mt-2 text-sm text-foreground-500 font-medium whitespace-nowrap">{metric.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}